import { useState, useContext, useEffect } from 'react';
import { ApiContext } from 'utils/networking/Api.context';
import { groupByKey } from 'utils/TextUtils';
import constants from 'utils/constants';
import { show2FAModal } from 'Components/common/TwoFactorModal/TwoFactorModal';

export default function usePaymentFormHook(updateEnabledHotels, hotelId) {
  const [state, setState] = useState({
    isLoading: false,
    data: null,
    orderedConfig: {},
    isTaxesSelected: false,
  });

  const { API } = useContext(ApiContext);

  useEffect(() => {
    if (state.orderedConfig?.payment_config) {
      const showTaxes = state.orderedConfig.payment_config.some(
        item =>
          item.key === 'payment' && constants.TOURIST_TAX_PAYMENT_TYPE_ENABLE.includes(item.value)
      );

      updateState({
        isTaxesSelected: showTaxes,
      });
    }
  }, [state.orderedConfig]);

  const actions = {
    loadPaymentConfig: (payment, hotelId) => {
      updateState({ isLoading: true });

      API.getHotelPaymentConfig({ platform: payment.name, hotelId })
        .then(res => {
          const orderedConfig = groupByKey(res, 'category');
          updateState({ data: res, orderedConfig, isLoading: false });
        })
        .catch(err => {
          updateState({ isLoading: false });
        });
    },

    onValueChanged: (key, text, splitValues) => {
      const dataCopy = state.data;
      for (const field of dataCopy) {
        if (field.key === key) {
          field.value = text;
          if (splitValues) {
            field.splitValues = splitValues;
          }
        }
      }

      if (key === 'payment') {
        updateState({ isTaxesSelected: constants.TOURIST_TAX_PAYMENT_TYPE_ENABLE.includes(text) });
      }

      updateState({ data: dataCopy });
    },

    getFieldValue: key => {
      const index = state.data.findIndex(x => x.key === key);
      return state.data[index]?.value;
    },

    onSave: async (payment, hotelId) => {
      updateState({ isLoading: true });

      const twoFAResult = await show2FAModal();

      if (twoFAResult === true) {
        const parameters = actions.formatParameters(state.data);
        API.updateHotelPaymentConfig({ hotelId, platform: payment.name, parameters })
          .then(res => {
            updateState({ isLoading: false });
            updateEnabledHotels && updateEnabledHotels();
          })
          .catch(err => {
            console.warn(err);
            updateState({ isLoading: false });
          });
      } else {
        updateState({ isLoading: false });
      }
    },

    formatParameters: data => {
      const parameters = {};
      for (const field of data) {
        parameters[field.key] = field.value;
      }

      return parameters;
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
